import React from 'react';
import { useTheme } from '../../../assets/contexts/ThemeContext';

/**
 * 그리드 간격 제어 컴포넌트
 * 원본: grid-control.html
 */
const GridControl = () => {
  const { themeConfig, set } = useTheme();
  const currentThemeConfig = themeConfig || {};
  const gridGap = currentThemeConfig.gridGap || 1.25;

  const updateGridGap = (gapValue) => {
    const numValue = parseFloat(gapValue);
    if (isNaN(numValue) || numValue < 0 || numValue > 5) return;
    const gapRem = numValue.toFixed(2) + 'rem';
    document.documentElement.style.setProperty('--grid-gap', gapRem);
    set('gridGap', numValue);
  };

  return (
    <div id="grid-gap-control-section">
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flex: 1 }}>
          <label style={{ fontWeight: 'bold', color: '#333', fontSize: '13px', margin: 0, flex: 1 }}>📐 그리드 간격 (Gap):</label>
          <button
            type="button"
            className="theme-help-btn"
            data-target="grid-gap-control-section"
            style={{
              background: 'transparent',
              border: '1px solid #ddd',
              color: '#666',
              fontSize: '11px',
              width: '20px',
              height: '20px',
              padding: 0,
              borderRadius: '50%',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
            title="이 항목으로 이동"
          >
            ?
          </button>
        </div>
        <button
          type="button"
          onClick={() => updateGridGap(1.25)}
          style={{
            background: 'transparent',
            border: '1px solid #ddd',
            color: '#666',
            fontSize: '11px',
            padding: '4px 10px',
            borderRadius: '3px',
            cursor: 'pointer',
            marginLeft: '6px'
          }}
        >
          리셋
        </button>
      </div>
      <div style={{ position: 'relative' }}>
        <input
          type="number"
          id="grid-gap-input"
          value={gridGap}
          onChange={(e) => {
            const value = parseFloat(e.target.value);
            if (!isNaN(value) && value >= 0 && value <= 5) {
              updateGridGap(value);
            }
          }}
          onBlur={(e) => {
            const value = parseFloat(e.target.value);
            if (isNaN(value) || value < 0 || value > 5) {
              const currentValue = gridGap || 1.25;
              e.target.value = currentValue.toFixed(2);
              updateGridGap(currentValue);
            } else {
              e.target.value = value.toFixed(2);
            }
          }}
          step="0.05"
          min="0"
          max="5"
          style={{
            width: '100%',
            padding: '6px 10px',
            border: '1px solid #ddd',
            borderRadius: '4px',
            fontSize: '13px',
            fontFamily: 'monospace',
            textAlign: 'center'
          }}
        />
        <div style={{ position: 'absolute', right: '8px', top: '50%', transform: 'translateY(-50%)', fontSize: '11px', color: '#999', pointerEvents: 'none' }}>rem</div>
      </div>
    </div>
  );
};

export default GridControl;

